const input = require('../input/input');

const alias = Object.assign({}, input, {
    subelements: {
        confirmEdit: null,
        validationMessage: null
    },
    readFromComp: false,

    inited: function () {
        if (typeof this.hm.app.components[this.extraAttributes.readFromComponentId] !== typeof undefined) {
            this.readFromComp = this.hm.app.components[this.extraAttributes.readFromComponentId];
            this.readFromComp.element.addEventListener('keyup', () => { this.startTimer('generateAlias_' + this.id, () => { this.generateAlias(); })});
        }
    },

    generateAlias: async function () {
        this.hm.app.blockSubmitActions('alias_' + this.id);
        if (this.element.readOnly) {
            let data = {
                configHash: this.configHash,
                componentAction: 'generate',
                base: this.readFromComp.getValue()
            };

            let response = await this.hm.app.fetchJson('components', 'main', data);

            this.setValue(response.alias);
        }
        this.clearTimer('generateAlias_' + this.id);
        this.hm.app.releaseSubmitActions('alias_' + this.id);
    }
});

module.exports = alias;